import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts';
import { Layout } from '../Layout';

type PrivateRouteProps = {
  layout?: boolean;
  children?: React.ReactNode;
};

export const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ children, layout = true }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return <Navigate replace to="/" />;

  return layout ? (
    <>
      <Layout>{children}</Layout>
    </>
  ) : (
    <>{children}</>
  );
};
